export const mutations = {
  /**
   * SIMPLE SETTERS
   */
  setUserId(state, value) {
    state.userId = value;
  },
  setQuestion(state, value) {
    state.question = value;
  },
  setWrongEmail(state, value) {
    state.wrongEmail = value === true;
  },
  setInsuranceQuestions(state, value) {
    state.insuranceQuestions = value;
  },
  setToken(state, value) {
    state.token = value;
  },
  setResetToken(state, value) {
    state.resetToken = value;
  },
  setResetTokenVerified(state, value) {
    state.resetTokenVerified = value;
  },

  /**
   * Bringing state back to default
   * @param {*} state
   */
  clear(state) {
    state.userId = 0;
    state.token = false;
    state.question = "";
    state.wrongEmail = false;
    state.insuranceQuestions = [];
    state.resetToken = false;
    state.resetTokenVerified = 0;
  }
};
